<template>
  <div class="flex md:flex-col gap-x-16">
    <Button
      class="w-2/4 md:w-full flex rounded-3xl normal-case"
      variant="outlined"
      size="small"
      @click="$emit('clickInterested')"
    >
      <PencilIcon :height="16" :width="16" class="mr-4" /><span>I'm interested...</span>
    </Button>
    <Button
      size="small"
      variant="outlined"
      class="w-2/4 md:w-full flex md:mt-16 rounded-3xl normal-case"
      @click="$emit('clickNotAFit')"
    >
      <PencilIcon :height="16" :width="16" class="mr-4" /><span>Not a fit...</span>
    </Button>
  </div>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';
import PencilIcon from '@/graphics/icons/PencilIcon.vue';

export default {
  name: 'BaseButtons',
  components: { Button, PencilIcon },
};
</script>
